module.exports = __webpack_public_path__ + "static/media/msdireland.08018cfe.png";